<div>
	<p-dialog [(visible)]="visible" (onHide)="onDialogHide()" [modal]="true" [style]="{'width': '700px'}"
			  appendTo="body">

		<p-header>
			<span>{{dialogTitle}}</span>
		</p-header>

		<div style="overflow: hidden">
			<apikey [target]="target" [create]="create"></apikey>
		</div>

		<p-footer>
			<button type="button" pButton icon="fa fa-check" [disabled]="!enableOk" (click)="onOkClicked()" label="OK"></button>
			<button type="button" pButton icon="fa fa-close" (click)="onCancelClicked()" label="Cancel"></button>
		</p-footer>

	</p-dialog>

</div>
